import React from 'react';
import { Modal, Switch, TextField } from '@scale/scaleui';

interface TaskerScreeningGradingFiltersModalProps {
  open: boolean;
  onClose: () => void;
  showLlmGraded: boolean;
  setShowLlmGraded: (showLlmGraded: boolean) => void;
  filterSkillThresholds: TaskerScreeningWorkerSkillThresholds;
  setFilterSkillThresholds: (thresholds: TaskerScreeningWorkerSkillThresholds) => void;
  filterAllowUndefinedScore: boolean;
  setFilterAllowUndefinedScore: (allowUndefinedScore: boolean) => void;
}

export interface TaskerScreeningWorkerSkillThresholds {
  [key: string]: number | null;
}

const TaskerScreeningGradingFiltersModal: React.FC<TaskerScreeningGradingFiltersModalProps> = ({
  open,
  onClose,
  showLlmGraded,
  setShowLlmGraded,
  filterSkillThresholds,
  setFilterSkillThresholds,
  filterAllowUndefinedScore,
  setFilterAllowUndefinedScore,
}) => {
  return (
    <Modal open={open} onClose={onClose} theme="scale-theme" title="Table Filters">
      <div className="p-4">
        {Object.keys(filterSkillThresholds).map(skill => (
          <div key={skill} className="flex flex-row mb-4">
            <TextField
              id={skill}
              type="number"
              value={filterSkillThresholds[skill] ?? undefined}
              placeholder="Threshold"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFilterSkillThresholds({
                  ...filterSkillThresholds,
                  [skill]: parseInt(e.target.value) ?? 0,
                });
              }}
            />
            <p className="ml-4 text-neutral-500">Threshold for {skill}</p>
          </div>
        ))}
        <Switch
          label="Allow non-existing scores even if threshold value is set"
          altDescription="Allow non-existing scores even if threshold value is set"
          checked={filterAllowUndefinedScore}
          onCheckedChange={setFilterAllowUndefinedScore}
          className="mb-4"
        />
        <Switch
          label="Show LLM-Graded Screening Answers"
          altDescription="Show LLM-Graded Screening Answers"
          checked={showLlmGraded}
          onCheckedChange={setShowLlmGraded}
          className="mb-4"
        />
      </div>
    </Modal>
  );
};

export default TaskerScreeningGradingFiltersModal;
